module.exports = __webpack_public_path__ + "img/744.d66d3b3f.jpg";